export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Mollie"] = "Mollie";
    PaymentProvider["Payconiq"] = "Payconiq";
    PaymentProvider["Buckaroo"] = "Buckaroo";
    PaymentProvider["Stripe"] = "Stripe";
})(PaymentProvider || (PaymentProvider = {}));
export function getPaymentProviderName(type) {
    return type.toString();
}
//# sourceMappingURL=PaymentProvider.js.map